import { Download } from "lucide-react";
import React, { memo } from "react";

const ButtonDownload = memo(
  ({
    type,
    className,
    onClick,
    isImage,
    image,
    text,
    disabled,
    style,
    imgStyle,
    imgClassName,
    icon,
  }) => {
    return (
      <>
        <button
          type={type}
          className={`${className}`}
          onClick={onClick}
          disabled={disabled}
          style={style}
        >
          {icon && icon}

          {text}
        </button>
      </>
    );
  },
);

export default ButtonDownload;
